import { getContacts } from 'pricing-pages-lib/api/ContactsApi';
import { createRequestTypes, createRequestActions } from './helpers/RequestActions';
import makeFetchRequest from './helpers/makeFetchRequest';
import { CONTACTS } from './constants/RequestedDataTypes';
import { isDevPortalSelector } from '../selectors/ScopeSelectors';
export const FetchContactsInCrmRequestTypes = createRequestTypes(CONTACTS);
export const FetchContactsInCrmActions = createRequestActions(FetchContactsInCrmRequestTypes);
export const fetchNumContactsInCrm = () => (dispatch, getState) => {
  const state = getState();
  const isDevPortal = isDevPortalSelector(state);
  return makeFetchRequest({
    requestActions: FetchContactsInCrmActions,
    fetch: getContacts,
    payload: isDevPortal
  })(dispatch, getState, undefined);
};